import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { TripRequest } from '@marageti/z4-sdk/lib/travel/TripRequest';
import {
  OutlinedIcons,
  getFormattedDateShortMonthDDYYYY,
  useApiClient,
  useFetchImmutable,
  formatCountryCodesToString,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { TripRequestStatusChip } from '../list-cards/chips';

const TableTripRequest = ({ tripRequests }: { tripRequests: TripRequest[] | undefined }) => {
  const apiClient = useApiClient();
  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  if (!tripRequests || tripRequests.length === 0) {
    return (
      <Stack spacing={1.5} my={6} display="flex" alignItems="center" justifyContent="center">
        <OutlinedIcons.OutlinedExclamationCircleIcon color="disabled" sx={{ width: 48, height: 48 }} />
        <Typography variant="body" color="text.secondary" sx={{ textAlign: 'center' }}>
          There are no trip requests for this traveler
        </Typography>
      </Stack>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: 450, mt: 1, mb: 3 }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '150px' }}>Destination</TableCell>
            <TableCell sx={{ width: '120px' }}>Requested</TableCell>
            <TableCell sx={{ width: '120px' }}>Departure</TableCell>
            <TableCell sx={{ width: '175px' }}>Assigned To</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tripRequests?.map((tripRequest: TripRequest) => (
            <TableRow
              key={tripRequest.id}
              onClick={() => window.open(`/trip-requests/${tripRequest.id}`, '_blank')}
              sx={{
                textDecoration: 'none',
                '&:last-child td, &:last-child th': { border: 0 },
                cursor: 'pointer',
              }}
              hover
            >
              <TableCell component="th" scope="row" sx={{ width: '150px' }}>
                {countryCodes && formatCountryCodesToString(tripRequest.countries, countryCodes)}
              </TableCell>
              <TableCell sx={{ width: '120px' }}>{getFormattedDateShortMonthDDYYYY(tripRequest.createdAt)}</TableCell>
              <TableCell sx={{ width: '120px' }}>{getFormattedDateShortMonthDDYYYY(tripRequest.departureDate)}</TableCell>
              <TableCell sx={{ width: '175px' }}>{tripRequest.assignedToName || '-'}</TableCell>
              <TableCell><TripRequestStatusChip status={tripRequest.status} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableTripRequest;
